import { IconPlus } from '@tabler/icons-react'
import { forwardRef } from 'react'
import {
  FacesheetCardActionButton,
  type FacesheetCardActionButtonProps,
} from '#src/components/patient/detail-content/facesheet/FacesheetCardActionButton.tsx'

export type FacesheetCardAddButtonProps = Omit<
  FacesheetCardActionButtonProps,
  'children'
>

// The "add to this section" affordance — the actions cluster's most common
// shape.
export const FacesheetCardAddButton = forwardRef<
  HTMLButtonElement,
  FacesheetCardAddButtonProps
>((props, ref) => (
  <FacesheetCardActionButton ref={ref} {...props}>
    <IconPlus />
  </FacesheetCardActionButton>
))

FacesheetCardAddButton.displayName = 'FacesheetCardAddButton'
